import React, {useEffect, useRef, useState} from 'react';
import close from '../../../../images/close.svg'
import {Formik, Field} from "formik";
import {useTheme} from "../../../../App";
import css from "../../../main/logbook/LogBook.module.scss";
import TripInfoBlock from "./TripInfoBlock";
import YachtInfoBlock from "./YachtInfoBlock";
import SailingRegion from "./SailingRegion";
import TripDetails from "./TripDetails";
import * as Yup from "yup";
import {connect} from "react-redux";
import {addTrip, editTrip, getTripInvitations} from "../../../../redux/logbook/logbook-thunks";
import {dataApi} from "../../../../redux/data/data-api";
import {
  COUNTRIES,
  FINISH_COUNTRIES,
  FINISH_MARINAS,
  MARINAS,
  OPERATORS,
  YACHT_MODELS, YACHTS
} from "../../../../redux/data/data-types";
import {getCommonData} from "../../../../redux/data/data-thunks";
import {userApi} from "../../../../redux/user/user-api";
import {useTranslation} from "react-i18next";
import {profileApi} from "../../../../redux/profile/profile-api";
import {fromDateToStringDate, fromStringDateToDate, isCyrilic, testDate} from "../../../../utils";
import ShareChanges from "./ShareChanges";
import {readNotifications} from "../../../../redux/notifications/notifications-thunks";

const AddLogBook = ({closeModal, logItem, openCreateModel, onSaveInDraft, isCreateModel, inviteTrip, isInvite, ...props}) => {
  const {t} = useTranslation()
  const {isDark} = useTheme()
  const [crewFile, setCrewFile] = useState(null)
  const [selectedYacht, setSelectedYacht] = useState(logItem?.yacht ?? null)
  const [editBody, setEditBody] = useState(null)
  const tripInfoRef = React.createRef()
  const yachtInfoRef = React.createRef()
  const regionInfoRef = React.createRef()
  const detailsInfoRef = React.createRef()
  const [state, setState] = useState([
    {
      startDate: logItem ? new Date(logItem.start_date) : null,
      endDate: logItem ? new Date(logItem.finish_date) : null,
      key: 'selection'
    }
  ])
  useEffect(() => {
    if (logItem) {
      props.getCommonData(YACHT_MODELS, logItem.yacht_model?.name ?? logItem.yacht_model_name)
      props.getCommonData(OPERATORS, logItem.operator?.name ?? logItem.operator_name)
      props.getCommonData(MARINAS, logItem.start_marina?.name ?? logItem.start_marina_name)
      props.getCommonData(COUNTRIES, logItem.start_country?.name ?? logItem.start_country_name)
      props.getCommonData(FINISH_MARINAS, logItem.finish_marina?.name ?? logItem.finish_marina_name)
      props.getCommonData(FINISH_COUNTRIES, logItem.finish_country?.name ?? logItem.finish_country_name)
      props.getCommonData(YACHTS, logItem.yacht?.name, undefined, logItem.operator?.id)
      props.getTripInvitations(logItem.id)
    } else {
      props.getCommonData(YACHT_MODELS)
      props.getCommonData(OPERATORS)
      props.getCommonData(MARINAS)
      props.getCommonData(COUNTRIES)
      props.getCommonData(FINISH_MARINAS)
      props.getCommonData(FINISH_COUNTRIES)
      props.getCommonData(YACHTS)
    }
  }, [])
  const onSubmit = async (values, {setFieldError}, isDraft) => {
    let isAnyError = false
    let isDateErrors = false
    if (!isDraft) {
      if (state[0].startDate > state[0].endDate) {
        isAnyError = true
        setFieldError('dateStart', t('startDateBiggerEndDate'))
      }
      if (!props.yachtModels.find(y => y.name === values.model)) {
        isAnyError = true
        setFieldError('model', t('modelNotFound'))
      }
      if (!isCyrilic(values.yacht)) {
        isAnyError = true
        setFieldError('yacht', `${t('enter')} ${t('yachtName')} ${t('onlyEnglish')}`)
      }
      if (!isCyrilic(values.tripDetails)) {
        isAnyError = true
        setFieldError('tripDetails', `${t('enter')} ${t('tripDetails')} ${t('onlyEnglish')}`)
      }
      if (!isCyrilic(values.routeDetails)) {
        isAnyError = true
        setFieldError('routeDetails', `${t('enter')} ${t('routeDetails')} ${t('onlyEnglish')}`)
      }
      if (!values.isPrivateOwn && !props.operators.find(o => o.name === values.operator)) {
        isAnyError = true
        setFieldError('operator', t('operatorNotFound'))
      }
      if (!props.countries.find(c => c.name === values.countryStart)) {
        isAnyError = true
        setFieldError('countryStart', t('countryStartNotFound'))
      }
      if (!props.finishCountries.find(c => c.name === values.countryFinish)) {
        isAnyError = true
        setFieldError('countryFinish', t('countryFinishNotFound'))
      }
      if (!props.marinas.find(m => m.name === values.marinaStart) && values.marinaStart.length > 0) {
        isAnyError = true
        setFieldError('marinaStart', t('marinaStartNotFound'))
      }
      if (props.marinas.find(m => m.name === values.marinaStart)?.country !== undefined &&
        props.marinas.find(m => m.name === values.marinaStart)?.country?.name !== values.countryStart) {
        isAnyError = true
        setFieldError('countryStart', t('marinaNotFoundInCountry') + values.marinaStart)
      }
      if (!props.finishMarinas.find(f => f.name === values.marinaFinish) && values.marinaFinish.length > 0) {
        isAnyError = true
        setFieldError('marinaFinish', t('marinaFinishNotFound'))
      }
      if (props.finishMarinas.find(m => m.name === values.marinaFinish)?.country !== undefined &&
        props.finishMarinas.find(m => m.name === values.marinaFinish)?.country?.name !== values.countryFinish) {
        isAnyError = true
        setFieldError('countryFinish', t('marinaNotFoundInCountry') + values.marinaFinish)
      }
      if (values.isAddFavorite && !values.yacht) {
        isAnyError = true
        setFieldError('yacht', t('enterYachtName'))
      }
      if (values.isAddFavorite && !values.year) {
        isAnyError = true
        setFieldError('year', t('chooseYearYacht'))
      }
      if (values.dateStart && !testDate(values.dateStart)) {
        isDateErrors = true
        setFieldError('dateStart', t('invalidDate'))
      }
      if (values.dateFinish && !testDate(values.dateFinish)) {
        isDateErrors = true
        setFieldError('dateFinish', t('invalidDate'))
      }
    }
    if ((!isAnyError || isDraft) && !isDateErrors) {
      const yachtModelId = props.yachtModels.find(y => y.name === values.model)?.id ?? null
      const operatorId = props.operators.find(o => o.name === values.operator)?.id ?? null
      const roleId = props.crewRoles.find(c => c.name === values.role)?.id ?? null
      const startMarinaId = props.marinas.find(m => m.name === values.marinaStart)?.id ?? null
      const finishMarinaId = props.finishMarinas.find(f => f.name === values.marinaFinish)?.id ?? null
      const startCountryId = props.countries.find(c => c.name === values.countryStart)?.id ?? null
      const finishCountryId = props.finishCountries.find(f => f.name === values.countryFinish)?.id ?? null
      let crewFileLink = logItem ? logItem.crew_list_file_link : ''
      if (crewFile) {
        const response = await userApi.uploadFile(crewFile, true)
        crewFileLink = response.data.id
      }
      if (logItem) {
        let yachtId = logItem.yacht?.id ?? undefined
        let yachtTypeId = logItem.yacht?.yacht_type_id ?? logItem.yacht_type_id ?? undefined
        let year = values.year.length !== 0 ? values.year : undefined
        let yachtName = values.yacht.length !== 0 ? values.yacht : undefined

        if (!props.favoriteYachts?.find(f => f.yacht_id === selectedYacht?.id)) {
          if (logItem.yacht?.yacht_model_id !== (yachtModelId ?? undefined) || logItem.operator_id !== (operatorId ?? undefined) ||
            logItem.yacht?.year !== year || logItem.yacht?.name !== yachtName) {
            const response = await dataApi.addYacht({
              name: yachtName,
              year,
              yacht_model_id: yachtModelId ?? undefined,
              operator_id: operatorId ?? undefined,
              yacht_owner_name: values.owner,
              isPrivateOwn: values.isPrivateOwn
            })
            yachtId = response.data.id
            yachtTypeId = response.data.yacht_model?.yacht_type_id
            if (values.isAddFavorite) {
              await profileApi.addFavoriteYacht(yachtId, props.profile?.id)
            }
          } else {
            if (values.isAddFavorite) {
              await profileApi.addFavoriteYacht(logItem.yacht.id, props.profile?.id)
            }
          }
        } else {
          yachtId = selectedYacht.id
        }
        let body = null
        if (isInvite) {
          props.readNotifications(localStorage.getItem('notification'), true)
          props.addTrip(fromStringDateToDate(values.dateStart), fromStringDateToDate(values.dateFinish), roleId, startMarinaId, finishMarinaId,
            startCountryId, finishCountryId, values.isTides, values.nightHours, values.miles, yachtId,
            yachtTypeId, yachtModelId,
            !values.isPrivateOwn ? operatorId : null, values.routeDetails, values.tripDetails,
            values.isPrivateOwn ? values.owner : null, crewFileLink, !!isDraft, values.days, true, true, logItem.voyage_id)
        } else {
          body = [logItem.id, fromStringDateToDate(values.dateStart), fromStringDateToDate(values.dateFinish), roleId, startMarinaId, finishMarinaId,
            startCountryId, finishCountryId, values.isTides, values.nightHours, values.miles, yachtId,
            yachtTypeId, yachtModelId,
            !values.isPrivateOwn ? operatorId : null, values.routeDetails, values.tripDetails,
            values.isPrivateOwn ? values.owner : null, crewFileLink, !!isDraft, logItem.voyage_id, values.days]
          if (props.tripInvitations.length > 0) setEditBody(body)
          else {
            props.editTrip(...body)
            closeModal()
          }
        }
        if (body === null) closeModal()
      } else {
        let yachtId = null
        let yachtTypeId = null
        if (!props.favoriteYachts?.find(f => f.yacht_id === selectedYacht?.id)) {
          if (yachtModelId) {
            const response = await dataApi.addYacht({
              name: values.yacht,
              year: values.year,
              yacht_model_id: yachtModelId ?? undefined,
              operator_id: operatorId ?? undefined,
              yacht_owner_name: values.owner,
              isPrivateOwn: values.isPrivateOwn
            })
            yachtId = response.data.id
            yachtTypeId = response.data.yacht_model.yacht_type_id
            if (values.isAddFavorite) {
              await profileApi.addFavoriteYacht(yachtId, props.profile?.id)
            }
          }
        } else {
          yachtId = selectedYacht.id
        }
        props.addTrip(fromStringDateToDate(values.dateStart), fromStringDateToDate(values.dateFinish), roleId, startMarinaId, finishMarinaId,
          startCountryId, finishCountryId, values.isTides, values.nightHours, values.miles, yachtId,
          yachtTypeId, yachtModelId,
          !values.isPrivateOwn ? operatorId : null, values.routeDetails, values.tripDetails,
          values.isPrivateOwn ? values.owner : null, crewFileLink, !!isDraft, values.days)
        closeModal()
      }
      if (isDraft) {
        onSaveInDraft()
      }
    }
  }
  console.log(logItem)
  if (editBody) return <ShareChanges isDark={isDark} closeModal={() => {
    setEditBody(null)
    closeModal()
  }} onSubmit={() => props.editTrip(...editBody, true)} cancel={() => props.editTrip(...editBody)}/>
  return (
    <div className={`modal w-830 ${isCreateModel && 'hidden-block'} ${isDark && 'modal__dark'}`}>
      <h5 className="modal__mainTitle mr-30">{logItem ? t('editTrip') : t('addTrip')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <Formik
        initialValues={{
          dateStart: logItem ? fromDateToStringDate(logItem.start_date) : '',
          dateFinish: logItem ? fromDateToStringDate(logItem.finish_date) : '',
          days: logItem ? logItem.days !== 0 ? logItem.days : (new Date(logItem.finish_date) - new Date(logItem.start_date))/(24*3600*1000) : '',
          role: logItem?.role?.name ?? logItem?.role_name ?? '',
          isTides: logItem?.tidal ?? false,
          miles: logItem?.miles ? `${logItem?.miles}` : '',
          nightHours: logItem?.night_hours ? `${logItem?.night_hours}` : '',
          model: logItem?.yacht_model?.name ?? logItem?.yacht_model_name ?? '',
          modelId: logItem?.yacht?.yacht_model?.id ?? logItem?.yacht_model_id ?? '',
          yacht: logItem?.yacht?.name ?? logItem?.yacht_name ?? '',
          year: logItem?.yacht?.year ?? '',
          isPrivateOwn: !!logItem?.yacht?.owner_name,
          operator: logItem?.operator?.name ?? logItem?.operator_name ?? '',
          operatorId: '',
          owner: logItem?.yacht?.owner_name ?? '',
          isAddFavorite: false,
          marinaStart: logItem?.start_marina?.name ?? logItem?.start_marina_name ?? '',
          marinaStartId: logItem?.id ?? '',
          countryStart: logItem?.start_country?.name ?? logItem?.start_country_name ?? '',
          countryStartId: logItem?.start_country?.id ?? logItem?.start_country_id ?? '',
          isStartEqualsFinish: logItem?.start_marina?.id === logItem?.finish_marina?.id,
          marinaFinish: logItem?.finish_marina?.name ?? logItem?.finish_marina_name ?? '',
          marinaFinishId: logItem?.finish_marina?.id ?? logItem?.finish_marina_id ?? '',
          countryFinish: logItem?.finish_country?.name ?? logItem?.finish_country_name ?? '',
          countryFinishId: logItem?.finish_country?.id ?? logItem?.finish_country_id ?? '',
          routeDetails: logItem?.itinerary ?? '',
          tripDetails: logItem?.description ?? '',
        }}
        validationSchema={Yup.object({
          dateStart: Yup.string()
            .required(t('selectDates')),
          dateFinish: Yup.string()
            .required(t('selectDates')),
          role: Yup.string()
            .required(t('selectRole')),
          countryStart: Yup.string()
            .required(t('selectStartCountry')),
          countryFinish: Yup.string()
            .required(t('selectFinishCountry')),
          model: Yup.string()
            .required(t('selectModel'))
        })}
        onSubmit={onSubmit}>
        {({values, handleChange, ...formikProps}) => {
          return <>
            <div className={'modal__sections'}>
              <TripInfoBlock role={values.role} isTides={values.isTides} state={state} miles={values.miles}
                             nightHours={values.nightHours} setState={setState} handleChange={handleChange}
                             setFieldValue={formikProps.setFieldValue} errors={formikProps.errors}
                             dateStart={values.dateStart} dateFinish={values.dateFinish}
                             days={values.days} tripInfoRef={tripInfoRef}
                             submitCount={formikProps.submitCount} setFieldError={formikProps.setFieldError}/>
              <YachtInfoBlock isPrivateOwn={values.isPrivateOwn} year={values.year} model={values.model}
                              operator={values.operator} isAddFavorite={values.isAddFavorite} owner={values.owner}
                              yacht={values.yacht} isDark={isDark} openCreateModel={openCreateModel}
                              handleChange={handleChange} setFieldValue={formikProps.setFieldValue}
                              errors={formikProps.errors} selectedYacht={selectedYacht}
                              setSelectedYacht={setSelectedYacht} yachtInfoRef={yachtInfoRef}
                              submitCount={formikProps.submitCount} isEdit={logItem !== undefined}/>
              <SailingRegion marinaStart={values.marinaStart} marinaFinish={values.marinaFinish}
                             countryFinish={values.countryFinish} countryStart={values.countryStart}
                             routeDetails={values.routeDetails} isStartEqualsFinish={values.isStartEqualsFinish}
                             isDark={isDark} setFieldValue={formikProps.setFieldValue} handleChange={handleChange}
                             errors={formikProps.errors} submitCount={formikProps.submitCount}
                             isEdit={logItem !== undefined} regionInfoRef={regionInfoRef}/>
              <TripDetails tripDetails={values.tripDetails} crewFile={crewFile}
                           setCrewFile={setCrewFile} crew_list_file_link={logItem ? logItem?.crew_list_file_link : null}
                           handleChange={handleChange} isInvite={isInvite} setFieldValue={formikProps.setFieldValue}
                           errors={formikProps.errors} detailsInfoRef={detailsInfoRef}/>
            </div>
            <div className="modal__buttons">
              <div className="modal__actions">
                <button type={'submit'} onClick={formikProps.handleSubmit} className="submit-button">
                  {t('save')}
                </button>
                <button onClick={() => {
                  // props.acceptInvitation(false)
                  closeModal()
                }} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
                  <span className={'commonBtn__label'}>{t('cancel')}</span>
                </button>
              </div>
              <button onClick={() => {
                onSubmit(values, {setFieldError: formikProps.setFieldError}, true)
              }} className={`modal__save ${isDark && 'modal__saveDark'}`}>
                <span className={`commonBtn__label modal__saveLabel`}>{t('saveDraft')}</span>
              </button>
            </div>
          </>
        }}
      </Formik>
    </div>
  );
};

const mapStateToProps = (state) => ({
  yachtModels: state.dataReducer.yachtModels,
  operators: state.dataReducer.operators,
  countries: state.dataReducer.countries,
  finishCountries: state.dataReducer.finishCountries,
  marinas: state.dataReducer.marinas,
  finishMarinas: state.dataReducer.finishMarinas,
  crewRoles: state.dataReducer.crewRoles,
  favoriteYachts: state.profileReducer.favoriteYachts,
  profile: state.userReducer.profile,
  tripInvitations: state.logbookReducer.tripInvitations
})

export default connect(mapStateToProps, {addTrip, editTrip, getCommonData, getTripInvitations, readNotifications})(React.memo(AddLogBook))
